// load files from this directory into webpack (everything in ./ that ends in js and isn't this file
const renderFilesRequire = require.context('./', true, /(?<!index)^(?!.*\.test\.js$).*\.js$/)

for (const key of renderFilesRequire.keys()) {
  renderFilesRequire(key)
}
